import React from 'react';
import { IconButton } from '@mui/material';

const CircularIconButton = ({ 
  icon, 
  alt, 
  onClick, 
  'aria-label': ariaLabel,
  size = 32,
  iconSize = 16,
  ...props 
}) => {
  return (
    <IconButton
      onClick={onClick}
      onTouchEnd={(e) => {
        e.preventDefault();
        onClick?.(e);
      }}
      aria-label={ariaLabel}
      sx={{
        touchAction: 'manipulation',
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: '#ffffff',
        boxShadow: '0px 6px 26px #626B7D12',
        borderRadius: '12px',
        padding: '6px',
        '&:hover': {
          backgroundColor: '#F8F9FA',
        },
        ...props.sx
      }}
      {...props}
    >
      <img src={icon} alt={alt} style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
    </IconButton>
  );
};

export default CircularIconButton;
